export default "__VITE_ASSET__7LxrtDGH__"